import { CurrentBucket, MAX_REASONS, Reason } from "@fsl/shared";
import { RadioGroup } from "./RadioGroup.js";
import { CheckGroup } from "./CheckGroup.js";
import type { SurveyState } from "./types.js";

const BUCKETS = [
  { value: CurrentBucket.STEPPED_AWAY,  label: "We stepped away from club — wanting something real but saner" },
  { value: CurrentBucket.REC_READY_MORE, label: "Rec has been fine, but our kids are ready for more" },
  { value: CurrentBucket.NEW_TO_SPORTS,  label: "New to organized sports, looking for the right start" },
  { value: CurrentBucket.OTHER,          label: "Something else" },
] as const;

const REASONS = [
  { value: Reason.LOWER_PRESSURE,   label: "Lower pressure" },
  { value: Reason.MORE_FUN,         label: "More fun" },
  { value: Reason.MULTI_SPORT,      label: "Multi-sport variety" },
  { value: Reason.QUALITY_COACHING, label: "Quality coaching" },
  { value: Reason.SCHEDULE,         label: "Schedule / logistics" },
  { value: Reason.SIBLING,          label: "Sibling-friendly" },
  { value: Reason.PRICE,            label: "Price" },
] as const;

interface Props {
  state: SurveyState;
  patch: (p: Partial<SurveyState>) => void;
  onNext: () => void;
  canAdvance: boolean;
}

export function Step1({ state, patch, onNext, canAdvance }: Props): JSX.Element {
  return (
    <div className="step active" data-step="1">
      <div className="field">
        <div className="field-label">Which best describes your family right now?</div>
        <RadioGroup
          name="bucket"
          group="bucket"
          value={state.bucket}
          onChange={(v) => patch({ bucket: v })}
          options={BUCKETS}
        />
      </div>

      <div className="field">
        <div className="field-label">Top reasons you signed up</div>
        <div className="field-hint">Pick up to {MAX_REASONS}.</div>
        <CheckGroup
          name="reasons"
          group="reasons"
          values={state.reasons}
          onChange={(v) => patch({ reasons: v })}
          options={REASONS}
          max={MAX_REASONS}
        />
      </div>

      <div className="form-actions">
        <div></div>
        <div className="right-side">
          <button type="button" className="btn btn-primary" onClick={onNext} disabled={!canAdvance}>
            Next →
          </button>
        </div>
      </div>
    </div>
  );
}
